import "./phoneInputField.scss";
import { Form } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Field, useFormikContext, useField } from "formik";

const PhoneInputField = ({
  name,
  title,
  required,
  errorFromBackend,
  onChange
}) => {
  const { setFieldTouched, setFieldValue } = useFormikContext(name);
  const [, meta] = useField(name);
  const hasFormikError =
    meta.touched &&
    ((typeof meta.error === "string" && meta.error.trim()) || meta.error);

  return (
    <Form.Group>
      <Form.Label>{`${title}${required ? "*" : ""}`}</Form.Label>
      <Field name={name} type="phone">
        {({ field, meta }) => (
          <PhoneInput
            country={"ru"}
            onlyCountries={["ru", "by", "kz", "kg", "uz"]}
            onChange={(phone) => {
              setFieldValue(name, phone);

              setTimeout(() => {
                setFieldTouched(name);
              }, 100);

              onChange && onChange(phone);
            }}
            defaultErrorMessage="error"
            className={`signin-placeholder form-control phoneInput ${meta.error && meta.touched ? "is-invalid" : ""
              }`}
            value={field.value}
            countryCodeEditable={false}
            jumpCursorToEnd
            inputProps={{
              name: { name },
              required: Boolean(required)
            }}
          />
        )}
      </Field>
      {hasFormikError ? (
        <Form.Control.Feedback type="invalid">
          {meta.error}
        </Form.Control.Feedback>
      ) : errorFromBackend ? (
        <div className="form-error mb-2">{errorFromBackend}</div>
      ) : (
        <Form.Text className="info-text">
          Введите номер (9-10 цифр, без + и кода страны)
        </Form.Text>
      )}
    </Form.Group>
  );
};

export default PhoneInputField;
